module.exports = __webpack_public_path__ + "media/images/lp/lp1-main-pc-758ad5f98be0652db0e392cb07dd100e.jpg";